import axiosInstance from "@libs/axios";

export interface MFADevice {
  id: number;
  deviceName: string;
  method: string;
  isActive: boolean;
  lastUsedAt: string | null;
  createdByName: string;
  createdAt: string;
}

export interface MFAStatusResponse {
  data: {
    mfaEnabled: boolean;
    devices: MFADevice[];
    enforcementInfo?: any;
  };
}

export interface MFASetupResponse {
  data: {
    deviceId: number;
    qrCodeUrl: string;
    secret: string;
    backupCodes: string[];
  };
  message: string;
}

export interface MFAVerifyResponse {
  data: null;
  message: string;
}

export const mfaService = {
  // Check MFA status
  async getStatus(): Promise<MFAStatusResponse> {
    const response = await axiosInstance.get("/api/v1/auth/mfa/status");
    return response.data;
  },

  // Setup MFA
  async setupMFA(deviceName: string, createdByName: string): Promise<MFASetupResponse> {
    const response = await axiosInstance.post(
      "/api/v1/auth/mfa/setup",
      {
        deviceName,
        createdByName,
      }
    );
    return response.data;
  },

  // Verify MFA setup
  async verifySetup(deviceId: number, code: string): Promise<MFAVerifyResponse> {
    const response = await axiosInstance.post(
      "/api/v1/auth/mfa/verify-setup",
      {
        deviceId,
        code,
      }
    );
    return response.data;
  },
};
